export const compose = (...fns) =>
  fns.reduce(
    (f, g) =>
      (...args) =>
        f(g(...args))
  );
export const pipe =
  (...functions) =>
  (data) =>
    functions.reduce((value, func) => func(value), data);
